module.exports = __webpack_public_path__ + "img/competition_benefit1.cf18a154.png";